import Foundation, { FOUNDATION_PROPTYPES } from '../Foundation'
import styles from './style/separator_style.module.scss';
import React from 'react'

const Separator = ({ ...props }) => {
    return (
        <Foundation {...props}>
            <div className={styles.separator}/>
        </Foundation>
    );
};

Separator.propTypes = FOUNDATION_PROPTYPES

export default Separator